import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountKeys } from '~teacher/hook/account';

import { transferOwnership } from '../../../api/teams/transferOwnership';
import { teamsKeys } from './teamsKeys';

export function useTransferTeamOwnership() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: transferOwnership,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [teamsKeys.all, accountKeys.account],
      });

      return window.location.reload();
    },
  });
}
